import Dropdown from "@/components/Dropdown";
import PropTypes from "prop-types";
import { ReactComponent as InformationCircle } from "@/assets/svgs/iconBadgeProgress.svg";
import { ReactComponent as IconConfigure } from '@/assets/svgs/info-circle.svg'
import classname from "classnames";
import Modal from "@/componentsDS/Modal/Modal";
import useModal from "@/hooks/use-modal/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Button from '@/components/Button';
import { MLETRPATH, IGPNIPATH } from '@/constants/etr/token-registry-redirection-path/index';

const TokenRegistryDropdown = ({
	tokenRegistryVersion,
	setTokenRegistryVersion,
	availableTokenVersions,
	selectedNetwork,
	showDropdown = false,
	showDropdownValue = false,
	showMessage = false,
}) => {
	const dropdownClassLabel = classname({
		"etr__record-details__modal__form__input__label": !!selectedNetwork,
		"etr__record-details__modal__form__input__label--disabled":
			!selectedNetwork,
	});

	/*=================================================
		Modal
	/================================================*/
	const {
		visible: isVisible,
		show: showTokenRegistryVersionModal,
		hide: hideTokenRegistryVersionModal,
	} = useModal();

	return (
		<>
			<div className="etr__record-details__section__content__grid__item etr__record-details__section__content__grid__item-height">
				<div className="etr__record-details__section__content__grid__token-registry">
					<label
						htmlFor="etr-dropdown"
						className={dropdownClassLabel}
					>
						{showDropdown && "* "}Token Registry Version:
					</label>
					<label
						htmlFor="learn-more"
						className="etr__record-details__section__content__grid__token-registry__input__label"
						onClick={showTokenRegistryVersionModal}
					>
						<InformationCircle /> Learn More
					</label>
				</div>
				{showDropdown && (
					<Dropdown
						placeholder="Select Option"
						style={{
							width: "100%",
							display: "flex",
							flexDirection: "column",
							gap: "8px",
						}}
						value={
							availableTokenVersions?.find(
								(option) =>
									option?.id === tokenRegistryVersion?.id
							)?.name
						}
						id="etr-dropdown"
						disabled={!selectedNetwork || availableTokenVersions?.length === 1}
					>
						{availableTokenVersions?.length > 0 &&
							availableTokenVersions?.map((tokenVersions) => (
								<Dropdown.Item
									key={tokenVersions.id}
									onClick={() =>
										setTokenRegistryVersion(tokenVersions)
									}
								>
									<div
										className={
											tokenRegistryVersion?.id ===
											tokenVersions.id
												? "etr__record-details__address__list__item-active"
												: "etr__record-details__address__list__item"
										}
									>
										<span className="etr__record-details__span">
											{tokenVersions.name}
										</span>
									</div>
								</Dropdown.Item>
							))}
					</Dropdown>
				)}
				{showDropdownValue && (
					<div className="etr__record-details__section__side-panel__label-value">
						{tokenRegistryVersion?.name}
					</div>
				)}
				{showMessage && selectedNetwork?.networkName && (
					<div className="etr__record-details__section__token-registry-message">
						Only some versions are supported for {selectedNetwork?.networkName}
					</div>
				)}
			</div>

			<Modal
				visible={isVisible}
				variant="medium"
				close={hideTokenRegistryVersionModal}
			>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={"card-configure__token-registry-version__icon"}>
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Token Registry Version
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="card-configure__token-registry-version__body__text">
                                TrustVC's Token Registry ensures all ETRs comply with <a href={MLETRPATH} target="_blank"><span className="card-configure__token-registry-version__body__text-mletr">MLETR</span></a> and <a href={IGPNIPATH} target="_blank"><span className="card-configure__token-registry-version__body__text-mletr">IGP&I</span></a> standards. 
								Version upgrades reflect enhancements to security, functionality, and compliance coverage.
							</div>
                            <br />
                            {(showDropdown || (showDropdownValue && tokenRegistryVersion?.id === "V5")) && <><div className="card-configure__token-registry-version__body__heading">V5 (MLETR + IGP&I):</div>
                                <div className="card-configure__token-registry-version__body__text card-configure__token-registry-version__body__padding">Issue secure and interoperable MLETR & IGP&I-compliant ETR documents.</div>
                                <div className="card-configure__token-registry-version__body__heading">New in v5:</div>
                                <div className="card-configure__token-registry-version__body__text card-configure__token-registry-version__body__left-padding">1. adds optional encrypted remarks for clearer transaction context.</div>
                                <div className="card-configure__token-registry-version__body__text card-configure__token-registry-version__body__left-padding">2. adds the ability to reject a transfer</div>
                            <br /></>}
                            {(showDropdown || (showDropdownValue && tokenRegistryVersion?.id === "V4")) && <><div className="card-configure__token-registry-version__body__heading">v4 (MLETR):</div>
                                <div className="card-configure__token-registry-version__body__text card-configure__token-registry-version__body__padding">Issue secure and interoperable MLETR-compliant ETR documents (i.e. focuses on legal equivalence to paper document, guaranteed singularity, and control of electronic records).</div>
                                <div className="card-configure__token-registry-version__body__text">Compatible with platforms using older Token Registry versions (e.g., v4). Choose v4 if your partners are not yet on v5</div>
                            </>}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								text="Dismiss"
                                full
                                round
								submit={() => {
									hideTokenRegistryVersionModal();
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	);
};

TokenRegistryDropdown.propTypes = {
	tokenRegistryVersion: PropTypes.string,
	setTokenRegistryVersion: PropTypes.func,
	availableTokenVersions: PropTypes.array,
    selectedNetwork: PropTypes.object,
    showDropdown: PropTypes.bool,
    showDropdownValue: PropTypes.bool,
	showMessage: PropTypes.bool,
};

export default TokenRegistryDropdown;
